import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentStatusFailed = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Refusé</title>
        <g clipPath="url(#clip0_740_21457)">
          <path
            d="M10.0042 0.779999C5.02998 0.779999 1 4.80998 1 9.78421C1 14.7585 5.02998 18.7884 10.0042 18.7884C14.9785 18.7884 19.0084 14.7585 19.0084 9.78421C19.0084 4.80998 14.97 0.779999 10.0042 0.779999ZM10.0042 2.64323C11.6314 2.64323 13.1321 3.19124 14.3377 4.11021L4.33021 14.1177C3.41124 12.9121 2.86323 11.4114 2.86323 9.78421C2.86323 5.83855 6.05855 2.64323 10.0042 2.64323ZM10.0042 16.9168C8.37705 16.9168 6.87635 16.3688 5.67073 15.4498L15.6698 5.45072C16.5888 6.65634 17.1368 8.15705 17.1368 9.78421C17.1368 13.7299 13.9415 16.9168 10.0042 16.9168Z"
            fill="#CB1517"
          />
        </g>
        <defs>
          <clipPath id="clip0_740_21457">
            <rect
              width="18"
              height="18"
              fill="white"
              transform="translate(1 0.779999)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default PaymentStatusFailed;
